module.exports = __webpack_public_path__ + "img/strip.a56ba36c.png";